



























































































import { Component } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate-3';

import InternationalizationService from '@/api/InternationalizationService';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import GoogleAddressFieldDropdown from '@/componentsV2/organisms/GoogleAddressFieldDropdown/GoogleAddressFieldDropdown.vue';

import { scrollToTop } from '@/utils/scrollToTop';

import { isExternalOauthSessionOnline } from '@/router/router-utils';

import { OnboardingURL } from '@/views/Onboarding/helpers';
import { createBusinessPayload } from '@/utils/createBusinessPayload';
import { omitNilProperties } from '@/utils/omitNilProperties';
import SignUpService from '@/api/SingupService';
import { removeCountryCode } from '@/utils/string';
import segmentIo from '@/utils/segment.io';
import { IBusinessType } from '@/models/business';
import BusinessOnboardingModel from '../../BusinessOnboardingModel.vue';
import Input from '@/componentsV2/molecules/Inputs/TextField.vue';
import { setFocusOnFirstInput } from '@/utils/setFocusOnFirstInput';

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    FilledButton,
    Typography,
    GoogleAddressFieldDropdown,
    Input
  }
})
export default class YourStoreAddress extends BusinessOnboardingModel {
  internationalizationService = new InternationalizationService();
  signUpService: SignUpService = new SignUpService();

  formData: any = {
    address: '',
    additionalAddress: '',
    name: '',
    googleData: {}
  };

  showAdditionalAddress = false;

  loading = false;

  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  get yourStoreFormData() {
    return this.$store.getters['businessOnboarding/getYourStoreForm'];
  }

  get yourStoreDetailsFormData() {
    return this.$store.getters['businessOnboarding/getStoreDetailsForm'];
  }

  get businessOnboardingState() {
    return this.$store.getters['businessOnboarding/getBusinessOnboardingState'];
  }

  get hasSameAddress() {
    return (
      !!this.businessOnboardingState.prefilledBusinessId &&
      this.formData.address
    );
  }

  get sameAddressText() {
    return 'This address is being used, try using another one or <a href="/">sign in</a> here.';
  }

  get isOnlineSignup() {
    return isExternalOauthSessionOnline();
  }

  get selectedCountry() {
    return this.$store.getters['businessOnboarding/getSelectedCountry'];
  }

  changedAdditionalAddress() {
    this.$store.dispatch('businessOnboarding/SET_PREFILLED_BUSINESS_ID', '');
  }

  contactOutTeam() {
    segmentIo.track('BFR Sign Up | Clicked Contact Our Team Button');
  }

  async handlePreValidateBusiness() {
    const businessData = createBusinessPayload(this.businessOnboardingState);

    const payload = {
      business: {
        ...omitNilProperties(businessData),
        name: ' ',
        countryIso2: this.yourStoreFormData.country.countryIso2,
        ...(this.formData.additionalAddress
          ? { addressAdditional: this.formData.additionalAddress }
          : {})
      }
    };

    const data = (await this.signUpService.preValidate(payload)) as any;

    if (data.status === 200) {
      this.$store.dispatch('businessOnboarding/SET_PREFILLED_BUSINESS_ID', '');

      return true;
    }

    const { response } = data;

    const errorData = response.data;

    if (
      errorData.slug &&
      errorData.slug === 'exceptions.business.theSameAddress'
    ) {
      if (this.showAdditionalAddress) {
        this.$store.dispatch(
          'businessOnboarding/SET_PREFILLED_BUSINESS_ID',
          errorData.data.businessId
        );
        segmentIo.page('BFR Sign Up | Existing Address');
      } else {
        segmentIo.page('BFR Sign Up | Additional Address');
        this.showAdditionalAddress = true;
        setTimeout(() => {
          setFocusOnFirstInput();
        }, 100);
      }
      return false;
    }
    return false;
  }

  handleClearAddress() {
    this.formData = Object.assign({}, this.formData, {
      address: null
    });
  }

  async handleSelect() {
    try {
      this.loading = true;

      this.showAdditionalAddress = false;
      this.formData.additionalAddress = '';

      const { data } = await this.signUpService.getGoogleAdressesDetail(
        (this.formData.address as any).id
      );

      this.formData.googleData = data;

      this.$store.dispatch('businessOnboarding/SET_STORE_DETAILS_FORM', {
        ...this.yourStoreDetailsFormData,
        address: data.location,
        aditionalAddress: ''
      });

      const response = await this.handlePreValidateBusiness();
      if (response) await this.onSubmit();
    } finally {
      this.loading = false;
    }
  }

  onSearch(text: string) {
    this.formData.name = text;
    this.formData.address = '';
  }

  goBack() {
    this.$router.push(OnboardingURL.YOUR_BUSINESS_OPERATION);
  }

  async onSubmit() {
    const formRef = this.$refs.observer;
    let formIsValid = true;
    if (
      !this.formData.name ||
      (this.showAdditionalAddress && !this.formData.additionalAddress)
    )
      formIsValid = await formRef.validate();

    if (!formIsValid) {
      this.$notification(
        String(this.$t('common.alerts.highlightedItemsError')),
        'error'
      );

      return;
    }

    if (!this.formData.address && this.formData.name) {
      this.$store.dispatch('businessOnboarding/SET_STORE_DETAILS_FORM', {
        ...this.yourStoreFormData,
        businessName: this.formData.name,
        website: '',
        completed: true,
        address: '',
        aditionalAddress: '',
        locationName: '',
        phone: {
          code: this.selectedCountry.phoneCode || '1',
          iso: this.selectedCountry.countryIso2 || 'US',
          number: ''
        },
        subCategories: undefined
      });
      this.$store.dispatch('businessOnboarding/SET_SELECTED_CATEGORY', {
        id: '',
        otherValue: ''
      });
      this.$router.push(OnboardingURL.YOUR_BUSINESS_COMPLETE);
      return;
    }

    if (this.showAdditionalAddress) {
      try {
        this.loading = true;
        const response = await this.handlePreValidateBusiness();
        if (!response) return;
      } finally {
        this.loading = false;
      }
    }

    const parsedWebsite = this.formData.googleData.websiteUri
      ? new URL(this.formData.googleData.websiteUri).hostname
      : '';
    const completed =
      !parsedWebsite &&
      this.yourStoreFormData.operationType === IBusinessType.BOTH;

    this.$store.dispatch('businessOnboarding/SET_STORE_DETAILS_FORM', {
      address: this.formData.googleData.location,
      aditionalAddress: this.formData.additionalAddress,
      businessName: this.formData.googleData.name,
      locationName: this.formData.googleData.location.address,
      subCategories: this.formData.googleData.subcategories,
      website: parsedWebsite,
      phone: {
        code: this.selectedCountry.phoneCode || '1',
        iso: this.selectedCountry.countryIso2 || 'US',
        number: this.formData.googleData.internationalPhoneNumber
          ? removeCountryCode(
              this.formData.googleData.internationalPhoneNumber
            ).replace(/[^0-9]+/g, '')
          : ''
      },
      completed
    });

    const category = this.formData.googleData.category;

    const categories =
      this.$store.getters['businessOnboarding/getCategories'] || [];

    if (categories.find((item: any) => item.label === category.name))
      this.$store.dispatch('businessOnboarding/SET_SELECTED_CATEGORY', {
        ...category,
        otherValue: category.name.toLowerCase().includes('other')
          ? category.name
          : ''
      });
    else {
      const newCategory = categories.find((item: any) =>
        item.label.toLowerCase().includes('other')
      );
      this.$store.dispatch('businessOnboarding/SET_SELECTED_CATEGORY', {
        name: newCategory.label,
        id: newCategory.value,
        otherValue: newCategory.label
      });
    }

    this.saveBusinessLead();

    if (completed) {
      this.$router.push(OnboardingURL.YOUR_BUSINESS_COMPLETE);
    } else {
      this.$router.push(OnboardingURL.YOUR_BUSINESS_PREVIEW);
    }
  }
  beforeDestroy() {
    this.$store.dispatch('businessOnboarding/SET_PREFILLED_BUSINESS_ID', '');
  }

  mounted() {
    this.$store.dispatch('businessOnboarding/SET_PREFILLED_BUSINESS_ID', '');
    scrollToTop('bo-base-layout__right');
  }
}
